import { EngineTheme } from '@websky/core/src/theme';

import Stepbar from './components/Stepbar/Stepbar.css';
import Toolbar from './components/Toolbar/Toolbar.css';
import Checkout from './components/Checkout/Checkout.css';
import Input from './components/Input/Input.css';
import Passenger from './components/Passenger/Passenger.css';
import PromoLoader from './components/PromoLoader/PromoLoader.css';
import Refund from './components/Refund/Refund.css';
import Inner from './components/Exchange/Inner/Inner.css';
import CommonSelect from './components/Exchange/CommonSelect/CommonSelect.css';
import Choice from './components/Exchange/Choice/Choice.css';
import Chip from './components/Exchange/Chip/Chip.css';
import CardExtra from './components/CardExtra/CardExtra.css';
import SearchFlights from './components/Exchange/SearchFlights/SearchFlights.css';
import FullscreenDialog from './components/FullscreenDialog/FullscreenDialog.css';
import Calendar from './components/Exchange/SearchFlights/Calendar/Calendar.css';
import FlightPrice from './components/FlightPrice/FlightPrice.css';
import DesktopFlightModalContent from './components/DesktopFlight/ModalContent/ModalContent.css';
import Location from './components/DesktopFlight/Location/Location.css';
import Day from './components/WeekCalendar/Day/Day.css';
import Slider from './components/WeekCalendar/Slider/Slider.css';
import DesktopFlightRoute from './components/DesktopFlightRoute/DesktopFlightRoute.css';
import SelectedFlights from './components/Exchange/SelectedFlights/SelectedFlights.css';
import Segment from './components/DesktopFlightRoute/Segment/Segment.css';
import CreateRequest from './components/Exchange/CreateRequest/CreateRequest.css';
import FlightCard from './components/FlightCard/FlightCard.css';
import RequestControls from './components/Exchange/RequestControls/RequestControls.css';
import Wrapper from './components/Refund/Wrapper/Wrapper.css';
import StepTitle from './components/Refund/StepTitle/StepTitle.css';
import ReasonForm from './components/Refund/ReasonForm/ReasonForm.css';
import Reason from './components/Refund/Reason/Reason.css';
import RefundPaper from './components/Refund/RefundPaper/RefundPaper.css';
import RequestForm from './components/Refund/RequestForm/RequestForm.css';
import { default as ExchangeRequestForm } from './components/Exchange/RequestForm/RequestForm.css';
import Ticket from './components/Refund/Ticket/Ticket.css';
import Notes from './components/Refund/Notes/Notes.css';
import Status from './components/Refund/Status/Status.css';
import StepsButtons from './components/Refund/StepsButtons/StepsButtons.css';
import Flight from './components/MobilleFlight/Flight/Flight.css';
import DesktopFlight from './components/DesktopFlight/DesktopFlight.css';
import SearchForm from './components/SearchForm/SearchForm.css';
// import FlightPriceStyles from './components/FlightPriceStyles/FlightPriceStyles.css';
import DesktopSummaryFlightHeader from './components/DesktopSummaryFlight/Header/Header.css';
import Link from './components/Link/Link.css';
import Amenities from './components/Amenities/Amenities.css';
import Contacts from './components/Contacts/Contacts.css';
import SeatMap from './components/SeatMap/SeatMap.css';
// import HeaderEquipmentItem from './components/Baggage/UpgradeBaggageDialog/components/BaggageDialogHeader/HeaderEquipmentItem/HeaderEquipmentItem.css';
import CheckoutAdditionalService from './components/CheckoutAdditionalService/CheckoutAdditionalService.css';
import InsuranceProductView from './components/InsurancePage/InsuranceProductView/InsuranceProductView.css';
import SearchFormDatepickerStyles from './components/SearchFormDatepicker/SearchFormDatepicker.css';
import SearchFormDatepickerMonthHeader from './components/SearchFormDatepicker/Month/MonthHeader/MonthHeader.css';
import SearchFormDatepickerWeeklyHeader from './components/SearchFormDatepicker/Month/WeeklyHeader/WeeklyHeader.css';
import SearchFormDatepickerMonth from './components/SearchFormDatepicker/Month/Month.css';
import SearchFormDatepickerDay from './components/SearchFormDatepicker/Month/Day/Day.css';
import CheckinCard from './components/CheckinCard/CheckinCard.css';
import SeatMapDisclaimer from './components/SeatMapDisclaimer/SeatMapDisclaimer.css';
import Fare from './components/CompareFares/Fare.css';
import PassengersToolbar from './components/Checkout/PassengersToolbar/PassengersToolbar.css';
import TaxesTooltip from './components/TaxesTooltip/TaxesTooltip.css';
import FormsBooking from './components/Forms/Booking/Booking.css';

const theme: EngineTheme = {
	Forms: {
		Booking: {
			container: FormsBooking.container
		}
	},
	MobileStepbar: {
		MobileStepbarStyles: {
			stepbar: Stepbar.mobileStepbar__stepbar,
			stepbar__cartWrapper: Stepbar.mobileStepbar__cartWrapper
		},
		StepbarHeader: {
			header: Stepbar.stepbarHeader__header,
			price: Stepbar.stepbarHeader__price
		},

		StepbarServiceSummary: {
			content: Stepbar.serviceSummary__content
		}
	},
	Toolbar: {
		Toolbar: {
			price: Toolbar.toolbar__price,
			backButton__wrapper: Toolbar.toolbar__backButtonWrapper,
			backButton: Toolbar.toolbar__backButton
		}
	},
	CardExtra: {
		CardExtraContent: {
			root_seats: CardExtra.cardExtraContent__root_seats,
			root_animal: CardExtra.cardExtraContent__root_animal,
			root_baggage: CardExtra.cardExtraContent__root_baggage,
			root_meal: CardExtra.cardExtraContent__root_meal,
			root_insurance: CardExtra.cardExtraContent__root_insurance,
			header__icon: CardExtra.cardExtraContent__header_icon,
			header: CardExtra.cardExtraContent__header
		},
		CardExtraModal: {
			root_animal: CardExtra.cardExtraModal__root_animal,
			modal__closeButton: CardExtra.cardExtraModal__modal__closeButton
		}
	},
	Checkout: {
		CheckoutStyles: {
			gdsTotalPrice: Checkout.gdsTotalPrice
		},
		PassengersToolbar: {
			toolbarCheckbox__wrapper: PassengersToolbar.toolbarCheckbox__wrapper
		}
	},
	CompareFares: {
		Fare: {
			fareHeadingItem: Fare.fareHeadingItem
		}
	},
	ServiceSummary: {
		ServiceSummaryOption: {
			wrapper: Checkout.serviceSummary__wrapper
		}
	},
	Input: {
		Input: {
			input: Input.input,
			input_filled: Input.input_filled,
			real_input: Input.real_input,
			textField_filled: Input.textField_filled,
			input_focused: Input.input_focused,
			textField_focused: Input.textField_focused,
			label_error: Input.label_error,
			input_error: Input.input_error,
			input_standard: Input.input_standard
		}
	},
	Passenger: {
		PassengerSwitch: {
			element: Passenger.switch__element,
			element_active: Passenger.switch__element_active,
			element_error: Passenger.switch__element_error
		}
	},
	SeatMap: {
		AirplaneStyles: {
			airplane: SeatMap.airplane,
			airplane__name: SeatMap.airplane__name,
			segment: SeatMap.airplane__segment,
			seatsDetails: SeatMap.airplane__seatsDetails
		},
		PassengersStyles: {
			recommend__wrapper: SeatMap.recommend__wrapper,
			recommend: SeatMap.recommend
		},
		Passenger: {
			item: SeatMap.passenger__item,
			item_recommend: SeatMap.passenger__item_recommend,
			item_active: SeatMap.passenger__item_active,
			avatar: SeatMap.passenger__avatar,
			money: SeatMap.passenger__money
		},
		SeatMapDisclaimerStyles: {
			disclaimer__wrp: SeatMap.disclaimer__wrp,
			disclaimer: SeatMap.disclaimer
		},
		SeatsInfoStyles: {
			seat: SeatMap.seatInfo__seat,
			title: SeatMap.title,
			description: SeatMap.seatInfo__description,
			features: SeatMap.seatInfo__features,
			price__wrapper: SeatMap.seatInfo__priceWrapper,
			price: SeatMap.seatInfo__price
		},
		SeatStyles: {
			seat: SeatMap.seat,
			seat_recommend: SeatMap.seat_recommend,
			seat_recommendCurrent: SeatMap.seat_recommendCurrent,
			number: SeatMap.seat__number
		},
		SeatServiceSlide: {
			seat: SeatMap.seat
		},
		SeatMapStyles: {
			wings: SeatMap.seatMap__wings
		},
		SeatTooltipStyles: {
			tooltip: SeatMap.seatTooltip__tooltip,
			info: SeatMap.seatTooltip__info,
			tooltip_withInfo: SeatMap.seatTooltip__tooltip_withInfo
		}
	},
	PromoLoader: {
		PromoLoader: {
			promo__content: PromoLoader.promo__content,
			promo: PromoLoader.promo,
			promo__icon: PromoLoader.promo__icon,
			promo__image: PromoLoader.promo__image
		}
	},
	Refund: {
		Price: {
			total: Refund.price__total,
			row: Refund.price__row
		},
		StepTitle: {
			icon: StepTitle.stepTitle__icon,
			text: StepTitle.text,
			step: StepTitle.step
		},
		MobileStep: {
			header: Refund.mobileStep__header
		},
		Wrapper: {
			title: Wrapper.title,
			close__text: Wrapper.close__text,
			header_wrapper: Wrapper.header_wrapper
		},
		ReasonForm: {
			groupTitle: ReasonForm.groupTitle
		},
		RequestForm: {
			checkbox: RequestForm.checkbox,
			active: RequestForm.active,
			notes: RequestForm.notes,
			form: RequestForm.form
		},
		Reason: {
			active: Reason.active,
			label: Reason.label,
			radio: Reason.radio
		},
		RefundPaper: {
			paper: RefundPaper.paper
		},
		Ticket: {
			ticket: Ticket.ticket,
			refund__request: Ticket.refund__request,
			comments: Ticket.comments,
			button: Ticket.button,
			reject: Ticket.reject,
			prices: Ticket.prices,
			step: Ticket.step
		},
		Notes: {
			wrapper: Notes.wrapper
		},
		Status: {
			waiting: Status.waiting,
			icon: Status.icon
		},
		StepsButtons: {
			backButton: StepsButtons.backButton
		}
	},
	FullscreenDialog: {
		FullscreenDialog: {
			close__icon: FullscreenDialog.close__icon
		}
	},
	DesktopFlightRoute: {
		DesktopFlightRouteStyles: {
			flight: DesktopFlightRoute.flight,
			selected: DesktopFlightRoute.selected
		},
		FlightPriceStyles: {
			button: FlightPrice.button
		},
		SegmentStyles: {
			segment: Segment.segment,
			flightInfo__date: Segment.flightInfo__date
		}
	},
	DesktopFlight: {
		ModalContent: {
			fareGroup__button_active: DesktopFlightModalContent.fareGroup__button_active,
			scroll_up: DesktopFlightModalContent.scroll_up
		},
		Location: {
			terminal: Location.terminal
		},
		FlightInfoSegment: {
			location: DesktopFlight.location,
			isMobile: DesktopFlight.isMobile,
			flight: DesktopFlight.flight,
			card: DesktopFlight.card
		}
	},
	WeekCalendar: {
		DayStyles: {
			day: Day.day,
			day_selected: Day.day_selected,
			price: Day.price,
			date__info: Day.date__info
		},
		SliderStyles: {
			arrow: Slider.arrow
		}
	},
	Exchange: {
		Inner: {
			close__text: Inner.close__text,
			header: Inner.header,
			header__text: Inner.header__text
		},
		Selections: {
			reasons: Chip.reasons
		},
		CommonSelect: {
			container: CommonSelect.container,
			header: CommonSelect.header,
			icon: CommonSelect.icon,
			buttons: CommonSelect.buttons,
			button: CommonSelect.button,
			back: CommonSelect.back
		},
		Choice: {
			container: Choice.container,
			label: Choice.label,
			label_selected: Choice.label_selected,
			button: Choice.button,
			button_checked: Choice.button_checked,
			labelDate: Choice.labelDate
		},
		Chip: {
			close: Chip.close,
			chip: Chip.chip
		},
		SearchFlights: {
			header: SearchFlights.header,
			header__cities: SearchFlights.header__cities
		},
		Calendar: {
			calendar: Calendar.calendar
		},
		SelectedFlights: {
			header: SelectedFlights.header,
			charge: SelectedFlights.charge,
			header__name: SelectedFlights.header__name,
			flight__container: SelectedFlights.flight__container,
			money: SelectedFlights.money,
			total__money: SelectedFlights.total__money,
			total: SelectedFlights.total,
			change: SelectedFlights.change
		},
		CreateRequest: {
			container: CreateRequest.container,
			submit: CreateRequest.submit,
			button_checked: CreateRequest.button_checked
		},
		RequestForm: {
			request__main: ExchangeRequestForm.request__main,
			comment: ExchangeRequestForm.comment,
			chip: ExchangeRequestForm.chip,
			comment__header: ExchangeRequestForm.comment__header,
			comment__text: ExchangeRequestForm.comment__text
		},
		RequestControls: {
			button: RequestControls.button,
			container: RequestControls.container,
			text: RequestControls.text
		}
	},
	FlightCard: {
		FlightCard: {
			aircraft__nameTitle: FlightCard.aircraft__nameTitle,
			airline: FlightCard.airline,
			airline__number: FlightCard.airline__number,
			airline__name: FlightCard.airline__name
		}
	},
	CheckoutAdditionalService: {
		PetPopup: {
			header: CheckoutAdditionalService.petPopup__header,
			terms: CheckoutAdditionalService.petPopup__terms
		}
	},
	Results: {
		Results: {
			header__stepbar: Stepbar.stepbarHeader__header_desktop
		}
	},
	SearchForm: {
		Segment: {
			segment: SearchForm.segment__segment,
			wrapper: SearchForm.segment__wrapper,
			withMultiCity: SearchForm.segment__withMultiCity,
			cell: SearchForm.segment__cell,
			cell_location: SearchForm.segment__cell_location,
			input: SearchForm.segment__input,
			location__value: SearchForm.segment__location__value,
			datepicker_value: SearchForm.segment__datepicker_value,
			control: SearchForm.segment__control
		},
		Location: {
			switcher: SearchForm.location__switcher,
			switcher_alternative: SearchForm.location__switcher_alternative
		},
		Passengers: {
			passengers: SearchForm.passengers__passengers,
			passengers_isMultiCity: SearchForm.passengers__passengers_isMultiCity,
			passengers_withCurrency: SearchForm.passengers__passengers_withCurrency
		},
		Currency: {
			currency: SearchForm.currency__currency,
			selector: SearchForm.currency__currency__selector
		},
		StartSearch: {
			startSearch: SearchForm.startSearch__startSearch,
			startSearch_multiCity: SearchForm.startSearch__startSearch_multiCity
		},
		Actions: {
			addSegment: SearchForm.actions__addSegment,
			removeSegment: SearchForm.actions__removeSegment,
			addSegment_alternative: SearchForm.actions__addSegment_alternative,
			removeSegment_alternative: SearchForm.actions__removeSegment_alternative
		},
		Datepicker: {
			highlighted_minPrice: SearchFormDatepickerDay.highlighted_minPrice
		}
	},
	SearchFormDatepicker: {
		SearchFormDatepickerStyles: {
			footer__buttons: SearchFormDatepickerStyles.footer__buttons,
			footer__clear: SearchFormDatepickerStyles.footer__clear,
			footer__done: SearchFormDatepickerStyles.footer__done
		},
		MonthHeaderStyles: {
			monthHeader: SearchFormDatepickerMonthHeader.monthHeader,
			monthHeader__select_month: SearchFormDatepickerMonthHeader.monthHeader__select_month,
			monthHeader__select_year: SearchFormDatepickerMonthHeader.monthHeader__select_year
		},
		WeeklyHeaderStyles: {
			week: SearchFormDatepickerWeeklyHeader.week,
			day: SearchFormDatepickerWeeklyHeader.day
		},
		MonthStyles: {
			monthWrapper: SearchFormDatepickerMonth.monthWrapper,
			month: SearchFormDatepickerMonth.month,
			week: SearchFormDatepickerMonth.week,
			week_withPrice: SearchFormDatepickerMonth.week_withPrice
		},
		DayStyles: {
			day: SearchFormDatepickerDay.day,
			day_withPrice: SearchFormDatepickerDay.day_withPrice,
			day_hasPrice: SearchFormDatepickerDay.day_hasPrice,
			day_notAvailable: SearchFormDatepickerDay.day_notAvailable,
			day__price: SearchFormDatepickerDay.day__price,
			day_selected: SearchFormDatepickerDay.day_selected,
			highlighted_minPrice: SearchFormDatepickerDay.highlighted_minPrice
		}
	},
	DesktopSummaryFlight: {
		Header: {
			header__cell: DesktopSummaryFlightHeader.header__cell
		}
	},
	Link: {
		Link: {
			link: Link.link
		}
	},
	Amenities: {
		Amenities: {
			amenities__item: Amenities.amenities__item
		}
	},
	Contacts: {
		ContactsStyles: {
			footer__inner: Contacts.footer__inner
		}
	},
	MobileFlight: {
		FlightStyles: {
			flight: Flight.flight,
			flight_selected: Flight.flight_selected,
			readonly: Flight.readonly
		}
	},
	InsurancePage: {
		InsuranceProductView: {
			root: InsuranceProductView.root,
			header: InsuranceProductView.header,
			header__icon: InsuranceProductView.header__icon,
			header__badge: InsuranceProductView.header__badge
		}
	},
	CheckinCard: {
		CheckinCard: {
			root: CheckinCard.root
		}
	},
	SeatMap: {
		SeatMapDisclaimerStyles: {
			disclaimer: SeatMapDisclaimer.disclaimer
		}
	},
	Entities: {
		Fare: {
			TaxesTooltip: {
				root: TaxesTooltip.root
			}
		}
	}
};

export default theme;
